module.exports = __webpack_public_path__ + "media/mypage/images/special/007-37033161ce771680b3064a62027a7555.jpg";